import { Expose } from 'class-transformer';
import { BaseEntity } from '@core/entities/_extra';

export class EventVenueEntity extends BaseEntity {
  @Expose()
  venue = '';
}
